import { theme } from 'design-cannect'
import styled from 'styled-components'
import { temporaryTheme } from 'styles/theme'
import { TABLET_WIDTH } from 'utils/constants'

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 64px 48px 58px 48px;
  gap: 28px;

  :before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 0 0 100% 0;
    background-color: #78d8b7;
    width: 30%;
    height: 500px;
    transform: translate(0px, 20px) scale(1.2);
    z-index: -1;
    opacity: 0.2;
    filter: blur(80px);
    @media (max-width: 900px) {
      width: 20%;
    }
  }
  @media (${TABLET_WIDTH}) {
    gap: 0px;
  }

  @media (max-width: 900px) {
    padding: 64px 30px 30px 30px;
  }
`
export const LeftWrapper = styled.div`
  max-width: 660px;
  min-width: 550px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  @media (max-width: 900px) {
    min-width: auto;
  }
  @media (${TABLET_WIDTH}) {
    min-width: 598px;
  }
`
export const RightWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding-right: 48px;

  img {
    max-inline-size: 100%;
    block-size: auto;
    height: auto;
    object-fit: contain;
    min-width: min-content;
  }

  img:first-child {
    margin-top: -34px;
  }
`
export const Title = styled.h1<any>`
  font-size: ${({ isMobile }) => (isMobile ? '26px' : '46px')};
  font-weight: 500;
  font-family: 'Spartan', sans-serif;
  font-weight: 400;
  line-height: 140.5%;
  color: ${theme.colors.darkGrey};
  span {
    font-family: 'Spartan', sans-serif;
    font-weight: 600;
  }
  span:last-child {
    font-weight: 600;
    color: ${temporaryTheme.colors.sitePrimary};
  }
  @media (${TABLET_WIDTH}) {
    font-size: 45px;
  }
`
export const Subtitle = styled.p`
  line-height: 155%;
  font-size: 19px;
  font-family: 'Nunito', sans-serif;
  font-weight: 500;
  color: ${theme.colors.darkGrey};
  @media (max-width: 900px) {
    font-size: 15px;
  }
`
export const TextDiv = styled.div`
  text-align: start;
  max-width: 550px;
  display: flex;
  flex-direction: column;
  gap: 19px;
  a {
    text-decoration: none;
  }
  margin-bottom: 32px;
`
export const VideoDiv = styled.div`
  border-radius: 10px;
`
export const ButtonText = styled.p<{ color?: string }>`
  font-size: 17px;
  font-family: 'Nunito', sans-serif;
  color: ${({ color }) => color || theme.colors.darkGrey};
  font-weight: 600;
`
export const WhiteWrapp = styled.div<any>`
  width: 100%;
  display: flex;
  flex-direction: ${({ isDesktop }) => (isDesktop ? 'row' : 'column')};
  align-items: center;
  gap: 32px;

  margin-bottom: 30px;

  text-decoration: none !important;
`
